import { render, staticRenderFns } from "./MyRenewAffiliateRequestList.vue?vue&type=template&id=c3a380be"
import script from "./MyRenewAffiliateRequestList.vue?vue&type=script&lang=ts"
export * from "./MyRenewAffiliateRequestList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports